export default __webpack_public_path__ + "static/media/pencil.96f62943.svg";